import React, { useEffect, useState } from 'react';
import { MailIcon, MapPinIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { contact, navLinks } from '../data/site';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className="sticky top-0 z-50 w-full" data-id="element-155" data-mp="2wj5oi57ji564">
      <div className="hidden border-b border-line bg-parchment text-ink-70 md:block" data-id="element-156" data-mp="31bp0wyuhqu9c">
        <div className="mx-auto flex max-w-[1240px] items-center justify-between px-6 py-2 font-mono text-[11px] tracking-[0.06em]" data-id="element-157" data-mp="36bl6h2iu6tr0">
          <div className="flex items-center gap-5" data-id="element-158" data-mp="3bbfvf0j1x99f">
            <span className="flex items-center gap-1.5" data-id="element-159" data-mp="3fbgnhnz2piyy">
              <MapPinIcon className="h-3 w-3 text-green-dark" aria-hidden="true" data-id="element-160" data-mp="3fc9oe8bcpe96" />
              Nairobi
            </span>
            <span className="text-line" data-id="element-161" data-mp="2wihxtxyo4ak9">|</span>
            <span data-id="element-162" data-mp="2rkq551q78kf0">Nanyuki</span>
            <span className="text-line" data-id="element-163" data-mp="2rkgfjf92gf9u">|</span>
            <span data-id="element-164" data-mp="2mm5635moo6s5">Nakuru</span>
          </div>
          <a href={`mailto:${contact.email}`} className="flex items-center gap-1.5 transition-colors hover:text-ink" data-id="element-165" data-mp="2mmx1ogga64if">
            <MailIcon className="h-3 w-3" aria-hidden="true" data-id="element-166" data-mp="3fbvk7eobf8o9" />
            {contact.email}
          </a>
        </div>
      </div>

      <div className={`border-b border-line bg-paper/95 backdrop-blur transition-shadow ${scrolled ? 'shadow-[0_1px_0_rgba(11,35,35,0.12)]' : ''}`} data-id="element-167" data-mp="3adkad3y0sy61">
        <div className="mx-auto flex max-w-[1240px] items-center justify-between gap-6 px-6 py-3" data-id="element-168" data-mp="30leli332ewv2">
          <a href="#top" className="shrink-0" aria-label="Premier Advisory Services Ltd — home" data-id="element-169" data-mp="1xhdzuccyvx0">
            <Logo data-id="element-170" data-mp="3ta2ao9qxq6dw" />
          </a>

          <nav aria-label="Primary" className="hidden items-center gap-7 lg:flex" data-id="element-171" data-mp="3t9skal1z9x7o">
            {navLinks.map(link => <a key={link.href} href={link.href} className="font-mono text-[11px] uppercase tracking-[0.12em] text-ink-70 transition-colors hover:text-ink" data-id="element-172" data-mp="1wco7zzb85k6f">
                {link.label}
              </a>)}
          </nav>

          <div className="hidden items-center gap-5 md:flex" data-id="element-173" data-mp="18n3ckgxvwug9">
            <a href={`tel:${contact.phonePrimary.replace(/\s/g, '')}`} className="flex items-center gap-1.5 font-mono text-[12px] text-ink transition-colors hover:text-green-dark" data-id="element-174" data-mp="18lij6unb3hjz">
              <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-175" data-mp="yr08v6ndwnr7" />
              {contact.phonePrimary}
            </a>
            <a href="#contact" className="bg-green px-5 py-3 font-mono text-[11px] uppercase tracking-[0.1em] text-ink transition-colors hover:bg-green-dark hover:text-white" data-id="element-176" data-mp="2t36nkffhlmo9">
              Book Consultation
            </a>
          </div>

          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="border border-line p-2 text-ink lg:hidden" data-id="element-177" data-mp="mcboquc6399y">
            {open ? <XIcon className="h-5 w-5" data-id="element-178" data-mp="1555tywjznn0z" /> : <MenuIcon className="h-5 w-5" data-id="element-179" data-mp="154cwkm6x69vi" />}
          </button>
        </div>

        {open && <nav id="mobile-nav" aria-label="Mobile" className="border-t border-line bg-paper px-6 py-4 lg:hidden" data-id="element-180" data-mp="106ujqkps7ai8">
            <ul className="flex flex-col" data-id="element-181" data-mp="1f0zdx101eiss">
              {navLinks.map(link => <li key={link.href} className="border-b border-line/70 last:border-0" data-id="element-182" data-mp="1a260t9onwtt5">
                  <a href={link.href} onClick={() => setOpen(false)} className="block py-3 font-mono text-[12px] uppercase tracking-[0.12em] text-ink-70" data-id="element-183" data-mp="3guyplnh2n260">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <a href="#contact" onClick={() => setOpen(false)} className="mt-4 block bg-green px-5 py-3 text-center font-mono text-[11px] uppercase tracking-[0.1em] text-ink" data-id="element-184" data-mp="2cx4jr42v8cad">
              Book Consultation
            </a>
          </nav>}
      </div>
    </header>;
}